export default "https://assets.egbcdn.net/assets/packs/_/images/b-day/ribbon-b5c5fd947291c5875bb8909c1f38a120.svg";